import { useState } from "react";
import { Search } from "lucide-react";
import {
  HelpCategoryGrid,
  HelpQuickLinks,
  PageHeader,
  StatCard,
  Input,
} from "@/shared/components";
import { HELP_CATEGORIES } from "@/shared/components/help-index-sections";

export function HelpIndexPage() {
  const [searchQuery, setSearchQuery] = useState("");

  const totalArticles = HELP_CATEGORIES.reduce(
    (sum: number, cat) => sum + cat.items.length,
    0,
  );

  return (
    <>
      <PageHeader
        title="도움말"
        description="데이터랩툴즈 이용 가이드, 약관, FAQ를 확인하세요."
      />

      <div className="mb-6 grid gap-4 sm:grid-cols-3">
        <StatCard
          label="도움말 카테고리"
          value={`${HELP_CATEGORIES.length}개`}
          change="시작하기·이용권·파티·기능·약관"
          trend="neutral"
        />
        <StatCard
          label="가이드 문서"
          value={`${totalArticles}개`}
          change="전체 문서 수"
          trend="neutral"
        />
        <StatCard
          label="빠른 지원"
          value="3채널"
          change="1:1문의·API문서·커뮤니티"
          trend="neutral"
        />
      </div>

      <div className="mb-6">
        <Input
          type="text"
          placeholder="도움말 검색... (예: 이용권 등록, 키워드 분석)"
          value={searchQuery}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchQuery(e.target.value)
          }
          leadingIcon={<Search className="size-4" />}
          className="h-11 rounded-xl bg-surface-raised"
        />
      </div>

      <HelpQuickLinks />
      <HelpCategoryGrid />
    </>
  );
}
